module.exports = __webpack_public_path__ + "89dc9766f49e550536945d66679ffddb.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/team_daniel_mobile_teaser.jpg
// module id = 668
// module chunks = 0